import { classNames } from "@/lib/utils";
import { Error } from "@components/molecules/FormikInput";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string;
  setValue?: (name: string) => void;
  classNameOverrides?: string;
  error?: string | null;
}

const MessageName = ({ value, setValue, classNameOverrides, maxLength, error, disabled, ...props }: Props) => {
  return (
    <div
      className={classNames(
        "flex w-full flex-col items-stretch justify-between overflow-hidden !bg-transparent outline-none",
      )}
    >
      <input
        {...props}
        disabled={disabled}
        value={value}
        maxLength={maxLength}
        onChange={(e) => setValue && setValue(e.target.value)}
        placeholder="Tool name..."
        className={classNames(
          "w-full !bg-transparent px-12 py-[7px] pl-8 font-mono outline-0 !ring-0 placeholder:text-oldgray-500",
          "text-12-12 font-bold text-oldgray-900",
          classNameOverrides,
          error ? "!border-b border-oldred-500" : "",
        )}
      />
      <Error name={value} error={error} className="!text-10-10" />
    </div>
  );
};

export default MessageName;
